<template>
  <div class="pa-5">
    <v-data-table
        :headers="headers"
        :items="desserts"
        :items-per-page="20"
        sort-by="equipamentoText"
        class="elevation-1"
        :search="search"
        style="padding-top: 20px"
        id="my-table"
    >
      <template v-slot:top>

        <v-toolbar flat class="mb-3">
          <router-link :to="{ name: 'geral-candidato' }" style="color: #888888; text-decoration: none;">Candidatos</router-link>
          <v-icon>mdi-chevron-right</v-icon>
          <a href="javascript:void(0)" style="color: #888888; text-decoration: none;">Recursos</a>
        </v-toolbar>

        <v-toolbar flat class="mb-3">
          <v-text-field v-model="search" label="Buscar" class="mt-8" outlined append-icon="mdi-magnify"></v-text-field>
        </v-toolbar>

        <v-toolbar flat>

          <v-toolbar-title>
            <span>RECURSOS</span><br>
            <small style="color: #888888; font-size: 12px;">
              {{ candidato.nome }}
            </small>
          </v-toolbar-title>

        </v-toolbar>

        <v-toolbar flat>
          <dialog-create-candidato-recurso-component
              :sendDialog="dialog"
              :sendEditedIndex="editedIndex"
              :sendEditedItem="editedItem"
              :sendCandidato="candidato"
              :sendModelsFormCreate="modelsFormCreate"
              @returnDialog="dialog = $event"
              @returnEditedIndex="editedIndex = $event"
              @returnMessage="message = $event"
              @returnSnackbar="snackbar = $event"
              @returnInitialize="initialize"
          ></dialog-create-candidato-recurso-component>

          <dialog-delete-candidato-recurso-component
              :sendEditedIndex="editedIndex"
              :sendDialogDelete="dialogDelete"
              @returnDialogDelete="dialogDelete = $event"
              @returnEditedIndex="editedIndex = $event"
              @returnMessageDel="message = $event"
              @returnSnackbar="snackbar = $event"
              @returnInitialize="initialize"
          ></dialog-delete-candidato-recurso-component>
        </v-toolbar>

      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
      </template>

      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>

    </v-data-table>

    <snackbar-component :sendSnackbar="snackbar" :message="message" @returnSnackbar="snackbar = $event"></snackbar-component>
    <loading-component :overlay="overlay"></loading-component>

  </div>
</template>

<script>

import model from "@/modulos/model";
import LoadingComponent from "@/components/snippets/LoadingComponent";
import SnackbarComponent from "@/components/snippets/SnackbarComponent";
import DialogCreateCandidatoRecursoComponent from "@/components/geral/candidatos-recursos/DialogCreateCandidatoRecursoComponent.vue";
import DialogDeleteCandidatoRecursoComponent from "@/components/geral/candidatos-recursos/DialogDeleteCandidatoRecursoComponent.vue";

export default {
  components: {
    LoadingComponent,
    SnackbarComponent,
    DialogCreateCandidatoRecursoComponent,
    DialogDeleteCandidatoRecursoComponent,
  },
  data: () => ({

    dialog: false,
    dialogDelete: false,
    search: '',
    snackbar: false,
    message: {sucesso: false, erro: false},
    overlay: false,
    headers: [
      { text: 'Candidato', align: 'start', sortable: false, value: 'nomeCandidatoText' },
      { text: 'Situação', align: 'start', sortable: false, value: 'situacao' },
      { text: 'Observação', align: 'start', sortable: false, value: 'observacao' },
      { text: 'Ações', value: 'actions', sortable: false, width: '100px' },
    ],
    editedItem: {
      descricao: '',
    },
    defaultItem: {
      descricao: '',
    },
    desserts: [],
    editedIndex: 0,
    modelsFormCreate: [],
    candidato: {},
  }),
  created() {

    this.initialize()
  },
  methods: {

    initialize(){

      this.overlay = true

      model.apiGet('candidato-recurso', this.$route.params.id).then(response => {

        this.overlay = false

        this.candidato = response.data.candidato
        this.desserts = response.data.candidato.recursos
        this.modelsFormCreate = response.data.modelos

        console.log(response.data)
      })
    },
    editItem(item){

      console.log(item)
      this.editedIndex = item.id
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {

      this.editedIndex = item.id
      this.dialogDelete = true
    },
  },
}
</script>

<style scoped>

</style>
